module.exports = {
  footerText: "Copyright Arescoop © 2021",
};
